<template>
	<Modals
		:title="'Error Log Details'"
		:display="display"
		:parentTag="'form'"
		:novalidate="'novalidate'"
		@show="close"
	>
		<template #modal-content>
			<div class="error-log">
				<div class="error-log__error-code">
					Error Code: {{ errorLogDetails.errorCode }}
				</div>
				<div class="error-log__correlation-id">
					Correlation ID: {{ errorLogDetails.correlationId }}
				</div>
				<div class="error-log__comment-by">
					{{ errorLogDetails.errorDetail }}
				</div>
			</div>
		</template>
		<template #modal-footer>
			<ButtonGroup :items="buttonItems" />
		</template>
	</Modals>
</template>

<script>
import Modals from '@/components/shells/modal/modals';
import ButtonGroup from '@/components/forms/button/button-group';

export default {
	name: 'ErrorLogDetailsModal',
	components: {
		Modals,
		ButtonGroup
	},
	model: {
		prop: 'display',
		event: 'show'
	},
	props: {
		display: {
			type: Boolean,
			default: false
		},
		errorLogDetails: {
			type: Object,
			default: () => ({})
		}
	},
	data() {
		return {
			buttonItems: [
				{
					id: 'copyButtonModal',
					iconBeforeLabel: true,
					iconClassName: 'icon-copy',
					className: 'btn--has-icon',
					labelText: 'Copy',
					btnClick: this.copyDetails
				},
				{
					id: 'cancelButtonModal',
					className: 'btn--primary',
					labelText: 'Close',
					btnClick: this.close
				}
			]
		};
	},
	methods: {
		copyDetails(e) {
			if (e) e.preventDefault();
			this.$emit('copy', this.errorLogDetails);
		},
		close() {
			this.$emit('show', false);
		}
	}
};
</script>

<style lang="scss" scoped>
/*------------------------------------*\
  #BASE
\*------------------------------------*/
::v-deep .modal {
	@include mq($from: md) {
		width: 640px;
	}
}

/*------------------------------------*\
  #BASE TABLET-UP
\*------------------------------------*/
@include mq($from: md) {
	.error-log {
		width: 500px;
		max-height: 500px;
	}
}

.error-log {
	&__error-code {
		@include body-text('md');
		margin-bottom: $gutter-sm;
	}
	&__correlation-id {
		@include body-text('md');
		margin-bottom: $gutter-sm;
	}
	&__comment-by {
		@include body-text('regular');
		margin-top: $gutter-md;
	}
}
</style>
